
import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import cuid from "cuid";
import React from 'react'
import {BUY_BUTTON_KEY} from "../definitions";
import logic from './logic'
import Button from './button'
import {withTranslation} from "react-i18next";

const DecoratedButton = withTranslation('cart')(logic(Button))

DecoratedButton.defaultProps = Object.create({gfyPlugin: BUY_BUTTON_KEY}, {
  id: {
    enumerable: true,
    get: () => cuid()
  }
});
export default DecoratedButton
